export default {
  SET_ALPHA_IS_VALIDATED(state, isValidated) {
    state.alpha.isValidated = isValidated;
  },
};
